import React from 'react'
import Element from './Element'
import get from 'lodash/get';

const url = get(window, 'location.href', 'pocket.com');
const title = get(window, '__STATE__.shareUrls.articleTitle', '');
const excerpt = get(window, '__STATE__.shareUrls.articleExcerpt', '');
const twitterShareUrl = get(window, '__STATE__.shareUrls.twitter', '');
const emailShareUrl = get(window, '__STATE__.shareUrls.email', '');

export default ({isMobileOnly, isTopOfPage}) => (
      <Element
          article={{url}}
          isMobileOnly={isMobileOnly}
          isTopOfPage={isTopOfPage}
          twitterShareUrl={twitterShareUrl}
          emailShareUrl={emailShareUrl}
          title={title}
          excerpt={excerpt}
      />
)
